import { BaseSanitizer } from './BaseSanitizer';
import { PhoneNumberUtil } from 'google-libphonenumber';
export class PhoneNumberSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'PHONE_NUMBER', 'phoneNumbers', enabled);
        this.phoneUtil = PhoneNumberUtil.getInstance();
    }
    detectMatches(text) {
        return this.detectPhoneNumbers(text);
    }
    detectPhoneNumbers(text) {
        const matches = [];
        const patterns = [
            '\\+\\d{7,15}(?!\\d)',
            '(?:\\+?\\d{1,3}[-.\\s]?)?\\(?\\d{1,4}\\)?[-.\\s]?\\d{1,4}[-.\\s]?\\d{1,4}(?!\\d)',
            '\\d{9}(?!\\d)',
            '\\d{10,15}(?!\\d)',
            '\\d{3}[-.\\s]?\\d{3}[-.\\s]?\\d{4}(?!\\d)',
            '\\(?\\d{3}\\)?[-.\\s]?\\d{3}[-.\\s]?\\d{4}(?!\\d)'
        ];
        for (const pattern of patterns) {
            const regex = new RegExp(pattern, 'g');
            let match;
            while ((match = regex.exec(text)) !== null) {
                const potentialPhone = match[0];
                if (this.isValidPhoneNumber(potentialPhone)) {
                    matches.push({
                        originalText: potentialPhone,
                        tag: '',
                        startIndex: match.index,
                        endIndex: match.index + potentialPhone.length
                    });
                }
            }
        }
        return this.removeOverlappingMatches(matches);
    }
    isValidPhoneNumber(potential) {
        const cleaned = potential.replace(/[^\d+]/g, '');
        if (cleaned.length < 7 || cleaned.length > 15) {
            return false;
        }
        // Top 100 countries by population/economic significance for phone validation
        // ISO 3166-1 alpha-2 country codes
        const countryCodes = [
            // North America
            'US', 'CA', 'MX',
            // Europe
            'GB', 'DE', 'FR', 'IT', 'ES', 'PL', 'RO', 'NL', 'BE', 'GR', 'CZ', 'PT',
            'SE', 'HU', 'AT', 'CH', 'BG', 'DK', 'FI', 'SK', 'NO', 'IE', 'HR', 'LT',
            'SI', 'LV', 'EE', 'CY', 'LU', 'MT', 'RS', 'BA', 'AL', 'MK', 'ME', 'IS',
            'UA', 'BY', 'MD',
            // Asia
            'CN', 'IN', 'ID', 'PK', 'BD', 'JP', 'PH', 'VN', 'TH', 'MM', 'KR', 'MY',
            'NP', 'TW', 'LK', 'KH', 'LA', 'SG', 'HK', 'MO', 'MN', 'BN', 'BT', 'MV',
            // Middle East
            'TR', 'IR', 'IQ', 'SA', 'YE', 'SY', 'AE', 'IL', 'JO', 'LB', 'KW', 'OM',
            'QA', 'BH', 'PS',
            // Africa
            'NG', 'ET', 'EG', 'ZA', 'TZ', 'KE', 'UG', 'DZ', 'SD', 'MA', 'AO', 'GH',
            'MZ', 'MG', 'CM', 'CI', 'NE', 'BF', 'ML', 'MW', 'ZM', 'SN', 'ZW', 'RW',
            'GN', 'TN', 'BJ', 'SO', 'LY',
            // South America
            'BR', 'CO', 'AR', 'PE', 'VE', 'CL', 'EC', 'BO', 'PY', 'UY', 'GY', 'SR',
            // Central America & Caribbean
            'GT', 'HN', 'NI', 'CR', 'PA', 'CU', 'HT', 'DO', 'SV', 'JM', 'TT', 'PR',
            // Oceania
            'AU', 'NZ', 'PG', 'FJ',
            // Central Asia
            'KZ', 'UZ', 'TM', 'TJ', 'KG', 'AF', 'AZ', 'GE', 'AM'
        ];
        for (const countryCode of countryCodes) {
            try {
                const number = this.phoneUtil.parseAndKeepRawInput(potential, countryCode);
                if (this.phoneUtil.isPossibleNumber(number) && this.phoneUtil.isValidNumber(number)) {
                    return true;
                }
            }
            catch (e) {
                continue;
            }
        }
        // Also try parsing without a default region (for numbers with country code prefix)
        try {
            const number = this.phoneUtil.parseAndKeepRawInput(potential);
            if (this.phoneUtil.isPossibleNumber(number) && this.phoneUtil.isValidNumber(number)) {
                return true;
            }
        }
        catch (e) {
            return false;
        }
        return false;
    }
}
